export default __webpack_public_path__ + "static/media/step3done.e78fd777.png";